import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class GlobalSettingsActions {
    static getAccountSettingsLoggedInUser = createAction(
        '[Reminders:Global] Get Account Settings LoggedIn User',
        props()
    );

    static getAccountSettingsLoggedInUserSuccess = createAction(
        '[Reminders:Global] Get Account Settings LoggedIn User Success',
        props<{
            statusFromSatellite: boolean,
            statusToSatellite: boolean,
            strategyId: number,
            clientModuleType: string
        }>()
    );

    static getAccountSettingsLoggedInUserFail = createAction(
        '[Reminders:Global] Get Account Settings LoggedIn User Fail',
        props<{ errorMsg: string }>()
    );

    static saveSatelliteStatusToFrom = createAction(
        '[Reminders:Global] Save Satellite Status To From Settings',
        props<{ statusToSatellite: boolean, statusFromSatellite: boolean }>()
    );

    static saveSatelliteStatusToFromSuccess = createAction(
        '[Reminders:Global] Save Satellite Status To From Settings Success',
        props<{ statusToSatellite: boolean, statusFromSatellite: boolean }>()
    );

    static saveSatelliteStatusToFromFail = createAction(
        '[Reminders:Global] Save Satellite Status To From Settings Fail',
        props<{ errorMsg: string }>()
    );

    static attemptSaveAccountStrategy = createAction(
        '[Reminders:Global] Attempt Save Global (account) Strategy',
        props<{
            strategyId: number
        }>()
    );

    static saveAccountStrategy = createAction(
        '[Reminders:Global] Save Global (account) Strategy',
        props<{ strategyId: number }>()
    );

    static saveAccountStrategySuccess = createAction(
        '[Reminders:Global] Save Global (account) Strategy Success',
        props<{strategyId: number}>()
    );

    static saveAccountStrategyFail = createAction(
        '[Reminders:Global] Save Global (account) Strategy Fail',
        props<{ errorMsg: string }>()
    );

    static openConfirmDialog = createAction(
        '[Reminders:Global] Open Confirm Dialog',
        props<{ dialogMessage: string, strategyId: number}>()
    );

    static openConfirmDialogCancel = createAction(
        '[Reminders:Global] Open Confirm Dialog Revert');
}
